import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "certificate"
const CertificateIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.213 1.833a1 1 0 0 0 1.246.579 7.93 7.93 0 0 1 .857-.235 1 1 0 0 0 .779-1.132 8.942 8.942 0 0 0-2.882.788ZM5.82 4.921a1 1 0 0 1-1.364.171 9.05 9.05 0 0 1 2.022-2.199 1 1 0 0 1-.056 1.373 8.053 8.053 0 0 0-.602.655Zm-2.817 4.9a1 1 0 0 0 1.066-.868c.038-.295.093-.586.164-.873a1 1 0 0 0-.678-1.195 8.974 8.974 0 0 0-.552 2.936Zm1.723 3.512a1 1 0 0 1-.442 1.302 8.944 8.944 0 0 1-1.092-2.78 1 1 0 0 1 1.21.652c.092.281.2.557.324.826Zm3.208 4.698a1 1 0 0 0-.316-1.337 8.028 8.028 0 0 1-.715-.529 1 1 0 0 0-1.372.091 9.028 9.028 0 0 0 2.403 1.775Zm7.997.068a9.025 9.025 0 0 0 2.433-1.734 1 1 0 0 0-1.37-.114 8.026 8.026 0 0 1-.724.516 1 1 0 0 0-.34 1.332ZM13.773 2.197a1 1 0 0 1-.765-1.141 8.94 8.94 0 0 1 2.872.821 1 1 0 0 1-1.253.564 7.933 7.933 0 0 0-.854-.244Zm3.915.828a1 1 0 0 0 .025 1.375c.207.211.403.435.586.668a1 1 0 0 0 1.36.203 9.046 9.046 0 0 0-1.97-2.246Zm2.126 5.252a1 1 0 0 1 .708-1.178c.31.91.478 1.886.478 2.901v.048a1 1 0 0 1-1.044-.894 7.983 7.983 0 0 0-.142-.877Zm.965 3.712a1 1 0 0 0-1.219.634c-.097.28-.21.554-.337.821a1 1 0 0 0 .422 1.308c.522-.839.91-1.77 1.134-2.763ZM9 23v-6.674a7 7 0 1 1 6 0V23l-3-3-3 3Zm9-13a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-6 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm3-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
        </svg>
      }
    </span>
  )
}
export default CertificateIcon
